import { type Patient } from '../../guides/types';

export const PATIENTS_UPDATE = 'PATIENTS_UPDATE';

export type State = {
  patient: Patient,
};
